<template>
  <div>
    <div class="mdss-yy">
      <div class="layout" style="position:relative;">
        <label for="upAnlClsId" class="ir">카테고리</label>
        <select name="upAnlClsId" id="upAnlClsId" v-model="upAnlClsId" @change="selectMdssYearList(false)">
          <option :value="data.anlClsId" v-for="(data, idx) in mdssNaviList" v-bind:key="idx">{{ data.anlClsNm }}</option>
        </select>
        <swiper class="swiper" :options="swiperMdssOption">
          <swiperSlide v-for="(data, idx) in mdssYearList" v-bind:key="idx" :class="{on: anlClsId === data.anlClsId}">
            <a href="#/" @click="createMdssList(data.anlClsId)">{{ data.anlClsNm }}</a>
          </swiperSlide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>

      </div>
    </div>

    <div class="layout">
      <div class="mdss-down align-end">
        <div class="chk-box" v-for="(data, idx) in mdssFileList" v-bind:key="idx">
          <input type="checkbox" id="chk01" v-if="data.fileType === '01'" :value="{fileSeq: data.fileSeqNo, fileType: data.fileType, fileNm: data.fileNm}" v-model="mdssChkFileData">
          <label for="chk01" class="type01" v-if="data.fileType === '01'">
            <img src="../../assets/img/ico_mdss_type01.png" alt="항목정의서 아이콘">
            {{ data.cdNm}}
          </label>

          <input type="checkbox" id="chk02" v-if="data.fileType === '02'" :value="{fileSeq: data.fileSeqNo, fileType: data.fileType, filePathNm: data.filePathNm, fileSize: data.fileSize, fileNm: data.fileNm}" v-model="mdssChkFileData">
          <label for="chk02" class="type02" v-if="data.fileType === '02'">
            <img src="../../assets/img/ico_mdss_type02.png" alt="데이터파일 아이콘">
            {{ data.cdNm.replace(/\(.*$/, '') }}
          </label>
        </div>
        <a href="#modal1" id="downOpenBtn" class="mdss btn md_open_btn" @click="mdssFileDownEvent">
          파일다운로드
          <img src="../../assets/img/ico_mdss_down.png" alt="파일다운로드 아이콘">
        </a>
        <!--
        <a href="#/" class="mdss btn" @click="mdssRqstEvent" title="팝업창열기">
          <img src="../../assets/img/ico_mdss_record.png" alt="이력보기 아이콘">
          이력보기
        </a>
        -->
      </div>
      <div class="mdss-grid" v-show="rqstMstShow === 0">
        <div class="stat-type-head align-end">
          <div v-show="topAnlClsId == '131'" class="stat-search-msg">{{mdssMessage}}</div>
          <div v-show="topAnlClsId != '131'" class="stat-search-box2">
            <label for="mdssSearchText" class="ir">검색창</label>
            <input type="search" v-model="mdssSearchText" v-on:keyup.enter="searchMdssItmList" id="mdssSearchText">
            <button type="submit" @click="searchMdssItmList">검색</button>
          </div>
          <button type="button" v-show="statId != 'STBL-1014282'" class="puple btn" @click="mdssSelectMdssDown">선택항목 다운로드</button>
          <a href="#modal2" id="condCd" class="ir">condCd</a>
          <a href="#modal3" id="condSet" class="ir">condSet</a>
          <a href="#modal4" id="resultInfo" class="ir">resultInfo</a>
          <a href="#modal5" id="resultDetail" class="ir">resultDetail</a>
          <a href="#modal6" id="showComments" class="ir">showComments</a>
          <a href="#modal7" id="showBasicInfo" class="ir">showBasicInfo</a>
          <a href="#modal8" id="showManual" class="ir">showManual</a>
        </div>
        <div class="mdss-table-wrap">
          <table class="mdss-table">
            <caption class="ir">mdss테이블</caption>
            <colgroup>
              <col style="width:10%;">
              <col style="width:10%">
              <col style="width:10%">
              <col style="width:calc(70% - 220px)">
              <col style="width:110px;">
              <col style="width:110px;">
            </colgroup>
            <thead>
            <tr style="width:calc(100% - 70px);">
              <th scope="col" style="width:10%;">
                <div class="tbl-checkbox-box">
                  <input type="checkbox" id="chk_01" v-model="allSelected" :disabled="topAnlClsId == '131'" @change="selectAll">
                  <i></i>
                  <label for="chk_01">선택</label>
                </div>
              </th>
              <th scope="col" style="width:10%">번호</th>
              <th scope="col" style="width:10%">형태</th>
              <th scope="col" style="width:calc(70% - 220px)">항목</th>
              <th scope="col" style="width:110px;">조건설정</th>
              <th scope="col" style="width:110px;">조건삭제</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(data, idx) in mdssList" v-bind:key="idx">
              <td :data-th="idx+1">
                <div class="tbl-checkbox-box">
                  <input type="checkbox" :id="'chk'+idx" v-model="checkMdssItm" :value="data.rownum" :disabled="topAnlClsId == '131'" @change="checkConfirm($event)">
                  <i></i>
                  <label :for="'chk'+idx">선택</label>
                </div>
              </td>
              <td>{{ data.rownum }}</td>
              <td data-th="형태">{{ data.cdNm }}</td>
              <td data-th="항목" class="text-align-left">
                <div class="entry-txt">{{ data.itmNm }}</div>
                <input type="hidden" :id="data.rownum"
                       :value="data.itmId+'@'+data.dspOrdNo+'@'+data.n1stConVal+'@'+data.n1stConCd+'@'+data.cnctConCd+'@'+data.n2ndConCd+'@'+data.n2ndConVal"></td>
              <td style="display:none;"></td>
              <td class="btn-td"><button type="button" class="tbl-btn" :disabled="topAnlClsId == '131'" @click="setCon(data.itmId, data.cdNm, idx)" title="팝업창열기">입력</button></td>
              <td class="btn-td"><button type="button" class="tbl-btn" :disabled="topAnlClsId == '131'" @click="deleteCond(idx)">삭제</button></td>
            </tr>
            <tr v-if="mdssList == '' ">
              <td colspan="6">조회된 데이터가 없습니다.</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <MdssRqstMst :rqstMstetting="mdssRqstMstSetting()" v-show="rqstMstShow === 1"/>
    </div>

    <!-- MDSS 요청서 작성 모달창 -->
    <div class="modal_cnt" id="modal1" style="display:none;">
      <div class="modal-header">
        <h2>요청서 작성</h2>
        <a href="#" class="close_btn" @click.prevent="closeModal"><img src="../../assets/img/popup_close.png" alt="닫기"></a>
      </div>
      <div class="modal-content">
        <div class="agreement_page02" style="display:table;width:100%;">
          <dl class="align-start popup-table" >
            <dt><span style="color:red;">*</span> 통계명</dt>
            <dd>{{ this.anlClsNm}}</dd>
          </dl>
          <dl class="align-start popup-table">
            <dt><span style="color:red;">*</span> 데이터파일</dt>
            <dd>
              <div style="display: flex;">
                <div class="radio-box" style="margin-right:20px;">
                  <input type="radio" id="radio_chk05" v-model="mdssReqFileType" value="02">
                  <label for="radio_chk05">텍스트파일</label>
                </div>
                <div class="radio-box">
                  <input type="radio" id="radio_chk07" v-model="mdssReqFileType" value="07">
                  <label for="radio_chk07">CSV파일</label>
                </div>
              </div>
            </dd>
          </dl>
          <dl class="align-start popup-table" >
            <dt><label for="orgNm"><span style="color:red;">*</span>소속</label></dt>
            <dd><input type="text" ref="orgNm" v-model="orgNm" id="orgNm"></dd>
          </dl>
          <dl class="align-start popup-table" >
            <dt><span style="color:red;">*</span>사용목적</dt>
            <dd><label for="usePurpose" class="ir">usePurpose</label><input type="text" ref="usePurpose" id="usePurpose" v-model="usePurpose"></dd>
          </dl>
        </div>
        <p class="guide-txt"><span style="color: red">*</span> 는 필수 입력항목입니다.</p>
        <div class="btn-layout center">
          <button type="button" class="next-btn" @click.prevent="agreeMdssDownload">다운로드(추출요청)</button>
          &nbsp
          <button type="button" class="close-btn" @click.prevent="closeModal">취소</button>
        </div>
      </div>
    </div>

    <MdssCondModal :modalSettings="condSetting()"/>
    <MdssCondSetModal :modalConsetSettings="condSetSetting()"/>
    <MdssRqstModal />
    <MdssResultDetailModal :modalMdssResultSettings="mdssResultDetailSetting()"/>
  </div>

</template>

<script>
import * as api from "@/api/Statistics";
import MdssRqstMst from '@/components/MdssRqstMst'
import MdssCondModal from '@/components/MdssCondModal'
import MdssCondSetModal from '@/components/MdssCondSetModal'
import MdssRqstModal from '@/components/MdssRqstModal'
import MdssResultDetailModal from '@/components/MdssResultDetailModal'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import $ from "jquery";
import * as file from "@/api/common/file";

export default {
  name: "MDSSBoardView",
  components: {
    swiper,
    swiperSlide,
    MdssRqstMst,
    MdssCondModal,
    MdssCondSetModal,
    MdssRqstModal,
    MdssResultDetailModal,
  },
  props: {
    statName: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      statId: '',
      swiperMdssOption: {
        slidesPerView: 8,
        spaceBetween: 0,
        slidesOffsetBefore: 173,
        slidesOffsetAfter: 60,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      systemNm: '',
      email: '',
      phoneNo: '',
      name: '',
      orgNm: '',
      anlClsId: '',
      usePurpose: '',
      rqstPw: '',
      anlClsNm: '',
      agreeYn: '',
      $modalCnt: '',
      mdssNaviCnt: 0,
      mdssReqFileType: '02',
      topAnlClsId: '',
      mdssCreTme: '',
      mdssChkFileData: [],
      mdssYearList: [], // 연도 탭 list
      checkMdssItm: [], // mdss 항목 선택
      upAnlClsId: '',
      mdssSearchText: '',
      rqstMstShow: 0,
      mdssList: [], // mdss list
      mdssNaviList: [], // 초기 selectbox list
      mdssFileList: [],
      mdssMessage: '대용량 파일은 선택항목 다운로드(추출)를 제공하지 않습니다. 데이터파일을 다운받으신 후 활용하시길 바랍니다.',
      allSelected: false,
      mdssRqstMstList: [],
      mdssResultDetail: [],
      mdssRequestDetail: [],
      ettCmlptFlg: 'N',
      zipFileFlg: 'N',
      itmId: '',
      conCdList: [],
      checkCondIdx: 0,
      grpCdList: [],
      grpCdNm: '',
    }
  },

  methods: {

    /**
     * 데이터 갱신
     *
     * @param statId
     */
    reload(statId) {
      if (this.statId === statId) return;

      this.statId = statId;
      this.selectMdssNaviList();
    },

    // mdss 초기 selectbox 세팅
    async selectMdssNaviList () {
      // let isMdssShow = true

      const idParam = {
        tblMgmNo: this.statId
      }

      const getIdData = await api.selectMdssUpAnlClsId(idParam)

      if (getIdData.data == null) {
        //TODO 어떤 상황인지?
        //isMdssShow = false
      } else {
        this.topAnlClsId = getIdData.data
        const paramData = {
          upAnlClsId: getIdData.data
        }

        const mdssNaviListData = await api.selectMdssNavi(paramData)
        this.mdssNaviList = mdssNaviListData.data
        this.mdssNaviCnt = mdssNaviListData.data.length
        this.upAnlClsId = mdssNaviListData.data[0].anlClsId

        this.selectMdssYearList(true)
      }
    },

    // mdss 년도 탬 클릭시
    async createMdssList (anlClsId) {
      const params = {
        anlClsId: anlClsId
      }

      this.mdssChkFileData = [] // 파일다운로드 데이터 초기화
      this.mdssSearchText = '' // mdss 항목 검색창 초기화
      this.checkMdssItm = [] // 선택된 항목 초기화
      this.allSelected = false

      this.anlClsId = anlClsId

      const data = await api.selectMdssItmList(params)
      if (data.data.length > 0) {
        this.mdssList = data.data
        this.mdssCreTme = data.data[0].creTme
      } else {
        this.mdssList = ''
      }

      const fileData = await api.selectMdssFileList(params)
      this.mdssFileList = fileData.data
    },

    // 조건 삭제
    deleteCond (idx) {
      this.mdssList[idx].n1stConVal = ' '
      this.mdssList[idx].n1stConCd = ' '
      this.mdssList[idx].cnctConCd = ' '
      this.mdssList[idx].n2ndConCd = ' '
      this.mdssList[idx].n2ndConVal = ' '
    },

    // 코드형 조건설정 값 세팅
    condSetting () {
      const conCdList = this.conCdList
      return { conCdList }
    },

    // 코드형 외 조건설정 값 세팅
    condSetSetting () {
      const grpCdList = this.grpCdList
      return { grpCdList }
    },

    mdssRqstMstSetting () {
      const mdssRqstList = this.mdssRqstMstList
      const rqstMstShow = this.rqstMstShow
      return { mdssRqstList, rqstMstShow }
    },

    mdssResultDetailSetting () {
      const mdssResultDetail = this.mdssResultDetail
      const mdssRequestDetail = this.mdssRequestDetail

      return { mdssResultDetail, mdssRequestDetail }
    },

    // mdss 항목 검색
    async searchMdssItmList () {
      const params = {
        anlClsId: this.anlClsId,
        mdssSearchText: this.mdssSearchText
      }

      const data = await api.selectMdssItmList(params)
      this.mdssList = data.data
    },

    // mdss 파일다운로드 클릭 시
    mdssFileDownEvent (event) {
      const fileLength = this.mdssChkFileData.length

      if (fileLength === 0) {
        alert('다운받을 자료를 선택해 주세요.')
        return false
      }

      if (fileLength == 1) { // MDSS 1개 파일 다운로드
        if (this.mdssChkFileData[0].fileType === '01') { // 항목정의서일 때는 일반 다운로드
          this.ettCmlptFlg = 'N'
          this.commonMdssFileDownload()
        } else if (this.mdssChkFileData[0].fileType === '02') { // 데이터파일일 때는 동의 후 다운로드
          this.ettCmlptFlg = 'Y'
          this.zipFileFlg = 'N'

          this.$nextTick(function () {
            this.setModal($('#downOpenBtn'))
          })
        }
      } else { // 2개 함께 다운로드 받을 때는 압축 다운로드
        this.zipFileFlg = 'Y'
        this.ettCmlptFlg = 'N'
        this.$nextTick(function () {
          this.setModal($('#downOpenBtn'))
        })

        // this.mdssZipFileDownload()
      }
    },

    // mdss 이력보기 클릭 시
    mdssRqstEvent () {
      this.$nextTick(function () {
        this.setModal($('#resultInfo'))
      })
    },

    // 선택항목 다운로드 클릭 시
    mdssSelectMdssDown (event) {
      if (this.checkMdssItm == '') {
        alert('추출 요청하실 항목을 선택해주시기 바랍니다. 전체 데이터가 필요하시면 DATA파일을 다운로드 하시면 됩니다.')
        return false
      }
      this.ettCmlptFlg = 'N'
      this.zipFileFlg = 'N'

      this.$nextTick(function () {
        this.setModal($('#downOpenBtn'))
      })
    },

    selectAll () {
      // this.userIds = []
      this.checkMdssItm = []

      if (this.allSelected) {
        for (let i = 0; i < this.mdssList.length; i++) {
          this.checkMdssItm.push(this.mdssList[i].rownum)
        }
      }
    },

    // MDSS 항목 선택 시 class on
    checkConfirm (event) {
      this.allSelected = false
      // if($(event.target).is(":checked")){
      //   $(event.target).parent().parent().parent().addClass("on")
      // }else{
      //   $(event.target).parent().parent().parent().removeClass("on")
      // }
    },

    // 다운로드(추출요청) 클릭 시
    agreeMdssDownload () {
      if (this.orgNm === '') {
        alert('소속을 입력해 주세요.')
        this.$refs.orgNm.focus()
        return false
      }

      if (this.usePurpose === '') {
        alert('사용목적을 입력해 주세요.')
        this.$refs.usePurpose.focus()
        return false
      }

      if (this.ettCmlptFlg === 'Y') { // 데이터파일 다운로드
        this.saveRequest()
        this.commonMdssFileDownload()
      } else {
        if (this.zipFileFlg == 'Y') { // 압축파일 다운로드
          this.mdssZipFileDownload()
        } else { // 선택항목 다운로드
          if (window.confirm('추출시 시간이 소요될수 있습니다. 확인 버튼을 누르신 후 잠시 기다려주시기 바랍니다.')) {
            this.saveItmRequest()
          }
        }
      }

      this.closeModal()
    },

    // MDSS 요청내역 상세 보기
    async mdssResultDetailInfo (rqstNo) {
      const param = {
        rqstNo: rqstNo
      }

      const frm = new FormData()
      frm.append('rqstNo', rqstNo)

      const data = await api.selectMcstRqstMst(frm)

      // const data = await api.selectMcstRqstMst(param)
      this.mdssResultDetail = data.data

      const detailData = await api.selectRequestsDetails(param)
      this.mdssRequestDetail = detailData.data

      this.$nextTick(function () {
        this.setModal($('#resultDetail'))
      })
    },

    // 조건설정 입력 클릭 시
    async setCon (itmId, cdNm, idx) {
      this.checkCondIdx = idx

      if (cdNm === '코드형') {
        const params = {
          anlClsId: this.anlClsId,
          creTme: this.mdssCreTme,
          itmId: itmId
        }
        const data = await api.selectItmData(params)
        this.conCdList = data.data

        this.$nextTick(function () {
          this.setModal($('#condCd'))
        })
      } else {
        const param = {
          grpCd: '005'
        }
        const data = await api.selectMdssConSetCodeList(param)
        this.grpCdList = data.data
        this.grpCdNm = cdNm

        this.$nextTick(function () {
          this.setModal($('#condSet'))
        })
      }
    },

    // 조건설정 모달창에서 적용 클릭 시(코드형)
    saveConCd (checkConCd, conCdGubun) {
      this.mdssList[this.checkCondIdx].n1stConVal = checkConCd
      if (conCdGubun) {
        this.mdssList[this.checkCondIdx].n1stConCd = '07'
      }
      this.closeModal()
    },

    // 조건설정 모달창에서 적용 클릭 시(코드형 외)
    saveCondSet (n1stConCd, n1stConVal, cnctConCd, n2ndConCd, n2ndConVal) {
      let conVal1st = n1stConVal
      let conVal2nd = n2ndConVal

      if (this.grpCdNm == '문자형') {
        if (conVal1st != ' ') conVal1st = "'" + n1stConVal + "'"
        if (conVal2nd != ' ') conVal2nd = "'" + n2ndConVal + "'"
      }

      this.mdssList[this.checkCondIdx].n1stConCd = n1stConCd
      this.mdssList[this.checkCondIdx].n1stConVal = conVal1st
      this.mdssList[this.checkCondIdx].cnctConCd = cnctConCd
      this.mdssList[this.checkCondIdx].n2ndConCd = n2ndConCd
      this.mdssList[this.checkCondIdx].n2ndConVal = conVal2nd
    },

    async saveItmRequest () {
      let mdssItm = ''
      const finallyItem = []
      for (let i = 0; i < this.checkMdssItm.length; i++) {
        mdssItm = this.checkMdssItm[i]
        finallyItem.push(document.getElementById(mdssItm).value)
      }

      const frm = new FormData()
      frm.append('anlClsId', this.anlClsId)
      frm.append('startCreTme', this.mdssCreTme)
      frm.append('endCreTme', this.mdssCreTme)
      frm.append('creTme', this.mdssCreTme)
      frm.append('rqstDivCd', '1')
      frm.append('rqstGb', '01')
      frm.append('anlClsNm', this.anlClsNm)
      frm.append('orgNm', this.orgNm)
      frm.append('usePurpose', this.usePurpose)
      frm.append('ettCmlptFlg', this.ettCmlptFlg)
      frm.append('chkItmId', finallyItem.join('&'))
      frm.append('reqFileType', this.mdssReqFileType)

      const data = await api.savePostRequest(frm)

      // const data = await api.saveRequest(params)

      const downParams = {
        type: 'MDSS_EXPORT',
        rqstNo: data.data
      }

      await file.download(downParams)
    },

    async saveRequest () {
      const params = {
        anlClsId: this.anlClsId,
        startCreTme: this.mdssCreTme,
        endCreTme: this.mdssCreTme,
        creTme: this.mdssCreTme,
        rqstDivCd: '1',
        usePurpose: this.usePurpose,
        rqstGb:'01',
        anlClsNm: this.anlClsNm,
        orgNm: this.orgNm,
        ettCmlptFlg: this.ettCmlptFlg,
        rstFileNm4: this.getRealFileName(this.mdssChkFileData[0].fileNm),
        rstFilePathNm4: this.mdssChkFileData[0].filePathNm,
        rstFileSize4: this.mdssChkFileData[0].fileSize
      }

      const data = await api.saveRequest(params)
      // console.log(data.data)
    },

    // mdss 이력보기 목록
    async mdssRqstList (email, pword) {
      const params = {
        email: email,
        pword: pword
      }

      const frm = new FormData()
      frm.append('email', email)
      frm.append('pword', pword)

      const data = await api.selectMcstRqstMst(frm)

      // const data = await api.selectMcstRqstMst(params)
      this.mdssRqstMstList = data.data

      if (this.mdssRqstMstList.length === 0) {
        alert('해당 정보로 등록된 요청내역이 없습니다.')
        return false
      }

      this.rqstMstShow = 1
    },

    // mdss 파일 다운로드 공통
    async commonMdssFileDownload () {
      const params = {
        type: 'MDSS',
        anlClsId: this.anlClsId,
        fileMgmNo: this.mdssChkFileData[0].fileSeq,
        creTme: this.mdssCreTme,
        reqFileType: this.mdssReqFileType
      }
      await file.download(params)
      this.insertMdssDownLog(this.mdssChkFileData[0].fileNm)
    },

    // mdss 다운로드 로그 쌓기
    async insertMdssDownLog (fileNm) {
      const params = {
        downMenu: 'MDSS',
        downCntn: this.getRealFileName(fileNm)
      }

      const data = await api.insertExcelDownLog(params)

      if (data.data.resultCode < 0) {
      }
    },

    // 파일명 추출
    getRealFileName (fileName) {
      // 파일이름이 존재 하지 않을 경우 공백으로 반환
      if (fileName == undefined || fileName == '') {
        return ''
      }
      // 파일업로된 파일이 아닐경우 그대로 반환
      if (fileName.indexOf('upload') == -1) {
        return fileName
      }
      const idx = fileName.lastIndexOf('_')
      if (idx == -1) {
        return fileName
      }
      return fileName.substr(0, idx)
    },

    // mdss 모달창 세팅
    setModal (target) {
      // const $openBtn = $(target)
      let $modalCnt = $(target).attr('href')
      $modalCnt = $($modalCnt)
      // const $closeBtn = $modalCnt.find(".close_btn")

      this.$modalCnt = $modalCnt

      $modalCnt.before('<div id="mask"></div>')

      $(window).on('resize', this.centerPosition)

      $('#mask').add($modalCnt).stop().fadeIn('fast')
      $modalCnt.attr('tabIndex', 0).focus()

      // $(".next-btn").on("click",function(){
      //   this.centerPosition;
      // });

      $modalCnt.find('a:first, a:last').on('blur', function () {
        setTimeout(function () {
          if (!$modalCnt.find('a').is(':focus')) {
            $modalCnt.find('.close_btn').click()
          }
        }, 10)
      })

      this.centerPosition()
    },

    centerPosition () {
      const topPos = ($(window).height() - $(this.$modalCnt).outerHeight()) / 2
      const leftPos = ($(window).width() - $(this.$modalCnt).outerWidth()) / 2

      $(this.$modalCnt).css({ top: topPos, left: leftPos })
    },

    // mdss zip 파일 다운로드
    async mdssZipFileDownload () {
      const params = {
        anlClsNm: this.anlClsNm,
        anlClsId: this.anlClsId,
        creTme: this.mdssCreTme,
        startCreTme: this.mdssCreTme,
        endCreTme: this.mdssCreTme,
        rqstDivCd: '1',
        usePurpose: this.usePurpose,
        rqstGb: '01',
        orgNm: this.orgNm,
        ettCmlptFlg: 'Y',
        reqFileType: this.mdssReqFileType
      }

      const fileData = await api.saveMdssZip(params)

      const downParams = {
        type: 'MDSS_ZIP',
        fileNm: fileData.data.fileNm,
        directoryPath: fileData.data.directoryPath
      }

      await file.download(downParams)

      const fileNm = fileData.data.fileNm + '.zip'

      this.insertMdssDownLog(fileNm)
    },

    // mdss 초기 년도 탭 세팅
    async selectMdssYearList (selectGubun) {
      const paramData = {
        upAnlClsId: this.upAnlClsId
      }

      this.mdssChkFileData = [] // 파일다운로드 데이터 초기화

      const mdssNaviListData = await api.selectMdssNavi(paramData)
      this.mdssYearList = mdssNaviListData.data
      const anlClsId = mdssNaviListData.data[0].anlClsId

      let anlClsNm = '';

      if (selectGubun) {
        anlClsNm = this.statName + '(' + this.mdssNaviList[0].anlClsNm + ')'
      } else {
        anlClsNm = this.statName + '(' + $('#upAnlClsId option:selected').text() + ')'
      }

      this.anlClsNm = anlClsNm

      this.createMdssList(anlClsId)
    },

    // mdss 모달창 닫기
    closeModal () {
      $('#mask').add(this.$modalCnt).stop().fadeOut('fast', function () {
        $('#mask').remove()
      })

      this.agreeYn = ''
      this.rqstGb = ''
      this.mdssReqFileType = '02'
      this.orgNm = '';
      this.usePurpose = '';
    },
  },
}
</script>

<style scoped>
.chk-box {
  position: relative;
  width: 300px;
  height: 47px;
}

.mdss.btn {
  width: 300px;
}

.mdss-down .chk-box:last-of-type {
  margin-right: 200px;
}
</style>
